import React, {Component} from 'react';
import {Dialog} from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";
import PropTypes from 'prop-types';
import {css} from "@emotion/css";
import CloseIcon from '@mui/icons-material/Close';


const RaikoDefaultDialogPage = (
    {
        onClose,
        open,
        dialogSize = DialogSize.MEDIUM,
        children,
        pageTitle
    }) => {

    const handleClose = () => {
        onClose();
    };


    return (
        <Dialog onClose={handleClose} open={open} id={dialogSize}>
            <DialogTitle className={css`
              display: flex;
              flex-direction: row;
              width: 100%;
              justify-content: center;
              align-items: center !important;
              align-content: center !important;
            `}>
                <div className={css`flex-grow: 1;`}>{pageTitle}</div>
                <CloseIcon className={
                    css`cursor: pointer;

                      &:hover {
                        background: var(--color-primary-highlight);
                        border-radius: 50%;
                      }`} onClick={handleClose}/>

            </DialogTitle>

            <section className={css`display: flex;
              flex-direction: column;
              flex-grow: 1;
            `}>
                {children}
            </section>
        </Dialog>
    );
}

export default RaikoDefaultDialogPage;

RaikoDefaultDialogPage.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
};

export const DialogSize = {
    LARGE: "LargeDialogSize",
    MEDIUM: "MediumDialogSize",
    SMALL: "SmallDialogSize",
    WRAP_CONTENT: "WrapContentDialogSize",
}